import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from "@angular/forms";
import { DatePipe } from '@angular/common';

import { CommonmastersService } from "../../commonmasters/commonmasters.service";
import { LoanService } from "../shared/loan.service";
import { LoantransactionService } from "../shared/loantransaction.service";
import { Loan } from '../shared/loan';

import { ToasterserviceService } from "../../utility/shared/toasterservice.service";
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { Toastpayload } from "../../utility/shared/toastpayload";
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-loanreceipt',
  templateUrl: './loanreceipt.component.html',
  styleUrls: ['./loanreceipt.component.css']
})
export class LoanreceiptComponent implements OnInit {

  ReceiptNo: number = 0;
  AddButtonText: string;
  ErrorText: string;
  PaymentModeList: any[] = [];
  CustomerName: string;
  BalanceAmount: number;
  CustomerId: number;
  loan: Loan;
  btnvisibility: boolean = true;
  BankLedgerVisibility:boolean=false;
  BankLedgerList: any[] = [];
  toast: Toastpayload;
  CustomerAddress: string;

  constructor(private loanService: LoanService,
    public loantransactionService: LoantransactionService,
    private router: Router,
    private commonmastersService: CommonmastersService,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private toasterserviceService: ToasterserviceService,
    private ngxLoader: NgxUiLoaderService) { }

  ngOnInit() {

    this.route.params.subscribe(params => {
      this.ReceiptNo = +  params['Id']; // (+) converts string 'id' to a number
    });

    this.GetPaymentMode();
    this.GetBankLedgerList();
    this.resetForm();
    this.GetAutogeneratedNumber();

    if (Number.isNaN(this.ReceiptNo)) {
      this.loantransactionService.selectedLoantransaction.Id = 0;
      this.loantransactionService.selectedLoantransaction.Flag = 1;
      this.loantransactionService.selectedLoantransaction.IsActive = true;
      this.AddButtonText = "Save";
    }
    else {
      this.loantransactionService.selectedLoantransaction.Id = +this.ReceiptNo;
      this.loantransactionService.selectedLoantransaction.Flag = 2;
      this.loantransactionService.selectedLoantransaction.IsActive = true;
      this.AddButtonText = "Edit";
    }
  }


  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();

    this.loantransactionService.selectedLoantransaction = {
      Id: 0,
      TransactionNo: 0,
      LoanId: null,
      CentreId: 0,
      TransactionDate: JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"],
      CollectionAmount: null,
      PrincipleAmount: null,
      InterestAmount: null,
      BalanceAmount: 0,
      InstallmentNo: 0,
      IsPartPayment: true,
      IsLoanPreclosure: false,
      IsDeath: false,
      IsReceiptAmount: true,
      PaymentTypeId: 0,
      PaymentBankId: 0,
      ChequeNo: null,
      Remarks: null,
      EmployeeId: null,
      EmployeeBranchId: null,
      CompanyId: null,
      SaasId: null,
      CreatedDate: null,
      ModifiedDate: null,
      IsActive: false,
      Flag: null,
      ListByCentreId: true,

      CustomerName: null,
      LoanApprovedDate: null,
      LoanDemand: null,
      TotalDemand: null,
      SavingsId: null,
      SavingsDemand: null,
      DepositDate: null,
      IsOpening: false,
      
      GroupLoanDemand : 0,
      GroupSavingsDemand : 0,
      GroupTotalDemand : 0, 
    }
  }

  onSubmit(form: NgForm) {

    // if (form.value.CustomerId != null) {
    //   this.loanService.IUDLoanReceipt(form.value)
    //     .subscribe(data => {
    //       this.resetForm(form);
    //     this.router.navigate(['/loanreceiptlist']);
    //     })
    // }

    if (form.value.CustomerId != null) {

      this.toast = {
        message: "No Message Now!",
        title: 'Loan receipt',
        ic: {
          timeOut: 3000,
          closeButton: true,
        } as IndividualConfig,
        type: 'success',
      };

      // showing Loader 
      this.ngxLoader.start();

      this.btnvisibility = false; // hidding the button  
      if (form.value.IsLoanPreclosure == 2) { // Loan Preclosure without savings close
        form.value.Flag = 3;
      }

      this.loantransactionService.IUDLoantransaction(form.value)
        .subscribe(data => {
          // this.resetForm(form);
          if (data[0].ResponseStatus = 200) {
            this.toast.message = 'Loan receipt amount savings failed!'
            this.toast.type = 'error';
            this.toasterserviceService.showToast(this.toast);
            this.ErrorText = data[0].ResponseMessage
          }
          else {
            this.toast.message = 'Loan receipt amount successfully saved!'
            this.toast.type = 'success';
            this.toasterserviceService.showToast(this.toast);

            this.router.navigate(['/loanreceiptlist']);
          }
        })

      // Closing Loader
      this.ngxLoader.stop();
    }
  }

  GetAutogeneratedNumber(): any {
    if (this.loantransactionService.selectedLoantransaction.TransactionNo == 0) {
      const myAutoGeneratedId = this.commonmastersService.FetchAutogeneratedNumber()
        .toPromise()
        .then(res => {
          this.loantransactionService.selectedLoantransaction.TransactionNo = res[0].AutoGeneratedId;
          return Promise.resolve(res[0].AutoGeneratedId);
        })
        .catch(err => { console.log(err) });
    }
    else {
      this.loantransactionService.selectedLoantransaction.Id = + this.ReceiptNo;
    }
  }

  GetPaymentMode() {
    this.commonmastersService.FetchPaymentMode().subscribe(data => {
      this.PaymentModeList = data;
    })
  }

  GetBankLedgerList(){ 
    this.loantransactionService.FetchBankLedgerList()
    .toPromise()
    .then(data => {
      this.BankLedgerList = data;
    })
  }

  public LoanSearch(event: any): void {
    this.loan = new Loan();
    this.loan.Id = this.loantransactionService.selectedLoantransaction.LoanId;

    if (this.loantransactionService.selectedLoantransaction.LoanId != null) {

      this.btnvisibility = true; // unhidding the button 
      this.loanService.LoanApprovalByLoanNo(this.loan)
        .toPromise()
        .then(data => {
          console.log(data);
          // this.loanService.selectedLoanreceipt = data;
          // this.loanService.selectedLoanreceipt.PaymentId = 0;  
          // this.loanService.selectedLoanreceipt.LoanId = data.Id; // selecting the loan Id.
          // this.loanService.selectedLoan.CustomerId = data.CustomerId;
          // this.loanService.selectedLoanreceipt.IsActive =true;
          // this.loanService.selectedLoanreceipt.Flag = 1;
          // this.loanService.selectedLoanreceipt.ReceiptDate= new Date();

          // this.loantransactionService.selectedLoantransaction = data;
          this.CustomerName = data.CustomerName;
          this.BalanceAmount = data.LoanAmount;
          this.CustomerId = data.CustomerId;
          this.CustomerAddress = data.CustomerAddress;
          // this.loantransactionService.selectedLoantransaction.PaymentTypeId = 0;  
          // this.loantransactionService.selectedLoantransaction.LoanId = data.Id; // selecting the loan Id.
          // this.loanService.selectedLoan.CustomerId = data.CustomerId;
          // this.loantransactionService.selectedLoantransaction.IsActive =true;
          // this.loantransactionService.selectedLoantransaction.Flag = 1;
          // this.loantransactionService.selectedLoantransaction.TransactionDate= new Date();

          // datePipe.transform(LoanList[0].ReceiptDate, 'yyyy-MM-dd').toString()
          // console.log(this.loanService.selectedLoanreceipt);     

        })

      // this.loanService.FetchLoanByLoanNo(this.loanService.selectedLoan).subscribe(loandata => {
      //   this.loanService.selectedLoan = loandata;
      //   this.loanService.selectedLoan.CustomerId =loandata.CustomerId;
      //   // console.log(this.loanService.selectedLoan);
      // })

      event.preventDefault();
    }
  }

  ShowBankList(Id : number){
  
    if(Id == 2)//Bank
    {
     this.BankLedgerVisibility = true;
    }
    else{
     this.BankLedgerVisibility = false;
    }
   }
}
